<div class="wrapper__contentComponent--expediente container my-5">
  <div class="row mt-5">
    <div class="col-12">
      <h1 class="text-center">Administración de Justino</h1>
      <p class="justificado">
        La sección de administración de Justino permite gestionar los diferentes
        componentes del sistema para garantizar su correcto funcionamiento.
        Desde aquí, los administradores pueden configurar y administrar los
        agentes, dominios, roles, bases de conocimiento y encuestas.
      </p>
    </div>
  </div>
  <div class="row mt-3">
    <div class="col-12">
      <h3 class="text-center">Opciones de Administración</h3>
      <p class="justificado">
        En esta sección, los usuarios con permisos de administración pueden
        acceder a distintas herramientas para la gestión eficiente del sistema.
      </p>
    </div>
  </div>
  <div class="row mt-3">
    <div class="col-12">
      <div class="row g-3">
        <div class="col-12 col-md-6 col-lg-4" *ngFor="let func of functionAdm">
          <button class="btn btn-primary w-100 btn-opt" (click)="func.action()">
            {{ func.name }}
          </button>
        </div>
      </div>
    </div>
  </div>
  <ng-container *ngIf="isEditIntro">
    <div class="row mt-3 edit-intro-box">
      <div class="col-12">
        <h4>Editar introducción</h4>
        <p class="justificado">
          En esta sección, se puede editar el contenido de la introducción de
          Justino para los usarios no aunténticados.
        </p>
        <div>
          <form [formGroup]="formEditIntro" (ngSubmit)="onSubmit()">
            <div class="mb-3">
              <label for="description" class="form-label">Descripción</label>
              <textarea
                id="description"
                formControlName="description"
                rows="5"
                class="form-control"></textarea>
            </div>
            <button type="submit" class="btn-govco btn-govco">Guardar</button>
          </form>
        </div>
      </div>
    </div>
  </ng-container>
  <div class="row mt-5">
    <div class="col-12">
      <h3 class="text-center">Métricas de Justino</h3>
      <p class="justificado">
        El módulo de métricas proporciona información detallada sobre el
        rendimiento y uso del sistema Justino. Aquí, los administradores pueden
        visualizar estadísticas clave, como la cantidad de interacciones,
        desempeño de los agentes, respuestas efectivas y otros indicadores
        relevantes para la optimización del sistema.
      </p>
    </div>
  </div>
  <div class="row align-items-center mt-3">
    <app-power-bi-embed
      *ngIf="renderizarReporte"
      [embedUrl]="embedUrl"
      [embebedToken]="embedToken"
      [reportId]="reportId"
      [groupId]="groupId"
      [accessToken]="accessToken"
      [heigth]="height"
      [isZoomEnabled]="isZoomEnabled"
      [isMobile]="isMobile">
    </app-power-bi-embed>
  </div>
</div>
